const state = {
  tabList: []
}

const mutations = {

  setTabList(state, tabList) {
    state.tabList = tabList
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
